export const EMERALD_MIN_PURCHASE = 15;
export const EMERALD_MAX_PURCHASE = 500;
export const EMERALD_PRICE_TIERS = Object.freeze([]);

export const EMERALD_PACKAGES = Object.freeze([
  Object.freeze({ id: 'sprout', emerald: 15, priceCents: 490, label: 'Punhado Esmeralda', pileSize: 5 }),
  Object.freeze({ id: 'trail', emerald: 35, priceCents: 990, label: 'Bolsa Esmeralda', pileSize: 9 }),
  Object.freeze({ id: 'guild', emerald: 80, priceCents: 1990, label: 'Baú Esmeralda', pileSize: 14, featured: true }),
  Object.freeze({ id: 'vault', emerald: 220, priceCents: 4990, label: 'Cofre Esmeralda', pileSize: 20 }),
  Object.freeze({ id: 'mountain', emerald: 500, priceCents: 9990, label: 'Montanha Esmeralda', pileSize: 28 }),
]);

export function emeraldPackageFor(amount) {
  const quantity = Number(amount);
  if (!Number.isInteger(quantity)) return null;
  return EMERALD_PACKAGES.find((pack) => pack.emerald === quantity) || null;
}

export const emeraldTierFor = emeraldPackageFor;

export function quoteEmeraldPurchase(amount) {
  const quantity = Number(amount);
  const pack = emeraldPackageFor(quantity);
  if (!pack) return { ok: false, error: 'invalid_emerald_package' };
  return {
    ok: true,
    amount: quantity,
    unitPriceCents: Math.round(pack.priceCents / pack.emerald),
    totalCents: pack.priceCents,
    package: pack,
    tier: pack,
  };
}

export function formatBrlFromCents(cents) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Math.max(0, Math.round(Number(cents) || 0)) / 100);
}
